import {heightS,heightM,heightB} from './common';
// loading 
export const loadingBg = [
  {
    url:require('../assets/images/loading/bg-s.jpg'),
    height:heightS
  },
  {
    url:require('../assets/images/loading/bg-m.jpg'),
    height:heightM
  },
  {
    url:require('../assets/images/loading/bg.jpg'),
    height:heightB
  }
]
export const barOuter = {
  src:require('../assets/images/loading/loading-outer.png'),
  pos:[
    {
      left:-313,
      top:-90.5,
      height:heightB
    }
  ],
  size:{
    width:627,
    height:196
  }
}
export const barInner = {
  src:require('../assets/images/loading/loading-inner.png'),
  pos:[
    {
      left:-277,
      top:-22,
      height:heightB
    }
  ],
  size:{
    width:1,
    height:16
  }
}
